import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, Clock } from 'lucide-react';
import PageHeader from '@/components/ui/PageHeader';
import { POSTS } from '@/data/products';

export default function Blog() {
  const [feature, ...rest] = POSTS;
  return (
    <div data-testid="page-blog">
      <PageHeader
        eyebrow="Journal"
        title="Notes from"
        accent="the kitchen."
        description="Stories, recipes and the small rituals that go into every bottle of Sip Theory."
      />

      {/* Featured */}
      <section className="container-x py-10" data-testid="featured-post">
        <Link to={`/blog/${feature.slug}`} className="group glass-card rounded-3xl p-8 lg:p-12 grid grid-cols-1 lg:grid-cols-12 gap-10 items-center hover:border-gold/30 transition-all overflow-hidden">
          <div className="lg:col-span-5 relative rounded-3xl aspect-[4/5] overflow-hidden">
            <img src={feature.cover} alt={feature.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
            <div className="absolute inset-0 bg-gradient-to-t from-ink-950 via-ink-950/30 to-transparent" />
          </div>
          <div className="lg:col-span-7 space-y-4">
            <div className="flex items-center gap-3 text-[11px] tracking-[0.22em] uppercase text-bone-300/80">
              <span className="text-gold">{feature.category}</span>
              <span>•</span>
              <span>{feature.date}</span>
              <span>•</span>
              <span className="inline-flex items-center gap-1.5"><Clock className="w-3 h-3" /> {feature.readTime}</span>
            </div>
            <h2 className="font-display text-4xl lg:text-5xl text-bone-50 leading-tight">{feature.title}</h2>
            <p className="text-bone-200/85 leading-relaxed">{feature.excerpt}</p>
            <span className="inline-flex items-center gap-2 text-gold text-sm tracking-[0.22em] uppercase">
              Read story <ArrowRight className="w-4 h-4" />
            </span>
          </div>
        </Link>
      </section>

      {/* Grid */}
      <section className="container-x py-12">
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="post-grid">
          {rest.map((post) => (
            <Link
              key={post.slug}
              to={`/blog/${post.slug}`}
              className="group glass-card rounded-3xl p-6 flex flex-col gap-4 hover:border-gold/30 hover:-translate-y-1 transition-all duration-500"
              data-testid={`post-${post.slug}`}
            >
              <div className="relative rounded-2xl aspect-[5/3] overflow-hidden">
                <img src={post.cover} alt={post.title} className="absolute inset-0 w-full h-full object-cover" loading="lazy" />
                <div className="absolute inset-0 bg-gradient-to-t from-ink-950/70 to-transparent" />
              </div>
              <div className="flex items-center gap-2 text-[10px] tracking-[0.22em] uppercase text-bone-300/80">
                <span className="text-gold">{post.category}</span>
                <span>•</span>
                <span>{post.date}</span>
              </div>
              <h3 className="font-display text-xl text-bone-50 leading-snug">{post.title}</h3>
              <p className="text-sm text-bone-200/80 leading-relaxed line-clamp-2">{post.excerpt}</p>
              <span className="inline-flex items-center gap-1.5 text-xs text-bone-300/80 mt-auto">
                <Clock className="w-3 h-3" /> {post.readTime}
              </span>
            </Link>
          ))}
        </div>
      </section>
    </div>
  );
}
